import React, { useState, useEffect } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Row, Col } from "reactstrap";
import { toast } from "sonner";

const WorkLogModal = ({
  isOpen,
  toggle,
  onSubmit,
  workLog,
  isLoading,
  projects,
  user
}) => {
  const [formData, setFormData] = useState({
    project_id: "",
    title: "",
    work_summary: "",
    hours_spent: "",
    work_status: "In Progress",
    date: new Date().toISOString().split('T')[0]
  });

  useEffect(() => {
    if (workLog) {
      // Editing existing work log
      setFormData({
        project_id: workLog.project_id || "",
        title: workLog.title || "",
        work_summary: workLog.work_summary || "",
        hours_spent: workLog.hours_spent || "",
        work_status: workLog.work_status || "In Progress",
        date: workLog.date || new Date().toISOString().split('T')[0]
      });
    } else {
      // Adding new work log
      setFormData({
        project_id: "",
        title: "",
        work_summary: "",
        hours_spent: "",
        work_status: "In Progress",
        date: new Date().toISOString().split('T')[0]
      });
    }
  }, [workLog, isOpen]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Validation
    if (!formData.work_summary.trim()) {
      toast.error("Work summary is required");
      return;
    }

    if (!formData.hours_spent || parseFloat(formData.hours_spent) <= 0) {
      toast.error("Please enter valid hours spent");
      return;
    }

    onSubmit(formData);
  };

  const handleModalClose = () => {
    setFormData({
      project_id: "",
      title: "",
      work_summary: "",
      hours_spent: "",
      work_status: "In Progress",
      date: new Date().toISOString().split('T')[0]
    });
    toggle();
  };

  return (
    <Modal isOpen={isOpen} toggle={handleModalClose} size="lg">
      <ModalHeader toggle={handleModalClose}>
        {workLog ? "Edit Work Log" : "Add Work Log"}
      </ModalHeader>
      <form onSubmit={handleSubmit}>
        <ModalBody>
          <Row>
            <Col lg={6}>
              <div className="mb-3">
                <label className="form-label">Date *</label>
                <input
                  type="date"
                  className="form-control"
                  name="date"
                  value={formData.date}
                  onChange={handleChange}
                  required
                />
              </div>
            </Col>
            <Col lg={6}>
              <div className="mb-3">
                <label className="form-label">Project</label>
                <select
                  className="form-select"
                  name="project_id"
                  value={formData.project_id}
                  onChange={handleChange}
                >
                  <option value="">Select Project (Optional)</option>
                  {projects.map(project => (
                    <option key={project.id} value={project.id}>
                      {project.name}
                    </option>
                  ))}
                </select>
              </div>
            </Col>
            {/* <Col lg={12}>
              <div className="mb-3">
                <label className="form-label">Title</label>
                <input
                  type="text"
                  className="form-control"
                  name="title"
                  value={formData.title}
                  onChange={handleChange}
                  placeholder="Enter work title (optional)"
                />
              </div>
            </Col> */}
            <Col lg={6}>
              <div className="mb-3">
                <label className="form-label">Hours Spent *</label>
                <input
                  type="number"
                  step="0.01"
                  min="0.01"
                  max="24"
                  className="form-control"
                  name="hours_spent"
                  value={formData.hours_spent}
                  onChange={handleChange}
                  required
                />
                <small className="text-muted">Enter hours spent (0.5 for 30 minutes)</small>
              </div>
            </Col>
            <Col lg={6}>
              <div className="mb-3">
                <label className="form-label">Work Status *</label>
                <select
                  className="form-select"
                  name="work_status"
                  value={formData.work_status}
                  onChange={handleChange}
                  required
                >
                  <option value="In Progress">In Progress</option>
                  <option value="Completed">Completed</option>
                  {/* <option value="Pending">Pending</option>
                  <option value="Blocked">Blocked</option> */}
                </select>
              </div>
            </Col>
            <Col lg={12}>
              <div className="mb-3">
                <label className="form-label">Work Summary *</label>
                <textarea
                  className="form-control"
                  name="work_summary"
                  value={formData.work_summary}
                  onChange={handleChange}
                  rows="6"
                  placeholder="Describe what you worked on today. Be specific about tasks completed, progress made, and any challenges faced..."
                  required
                />
              </div>
            </Col>
          </Row>

          {workLog && (
            <div className="mt-3 p-3 bg-light rounded">
              <h6 className="text-muted">Work Log Information</h6>
              <div className="row">
                <div className="col-6">
                  <small><strong>Employee:</strong> {workLog.employer_name}</small>
                </div>
                <div className="col-6">
                  <small><strong>Role:</strong> {workLog.employer_role}</small>
                </div>
              </div>
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <Button type="button" color="light" onClick={handleModalClose}>
            Cancel
          </Button>
          <Button type="submit" color="primary" disabled={isLoading}>
            {isLoading
              ? (workLog ? "Updating..." : "Adding...")
              : (workLog ? "Update Work Log" : "Add Work Log")
            }
          </Button>
        </ModalFooter>
      </form>
    </Modal>
  );
};

export default WorkLogModal;